module.exports = __webpack_public_path__ + "static/media/image-1.3cfd1859.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/Blog/EmailSigs/image-1.jpg
// module id = 473
// module chunks = 0